import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TCartFormInitialValues } from "core/models/order.model";
import { TGetAllStoreProductsData } from "core/models/store-products.model";
import { CartState } from "./cart.types";

const initialState: CartState = {
  items: {},
  pendingOrder: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (
      state,
      action: PayloadAction<{
        product: TGetAllStoreProductsData;
        storeProductId: number;
        storeProductTitle: string;
      }>,
    ) => {
      const { product, storeProductId, storeProductTitle } = action.payload;

      const id = product.id;

      if (state.items[id]) {
        state.items[id].quantity += 1;
      } else {
        state.items[id] = {
          product,
          storeProductId,
          storeProductTitle,
          quantity: 1,
        };
      }
    },

    increase: (state, action: PayloadAction<number>) => {
      const item = state.items[action.payload];
      if (item) item.quantity += 1;
    },

    decrease: (state, action: PayloadAction<number>) => {
      const item = state.items[action.payload];
      if (!item) return;

      if (item.quantity === 1) {
        delete state.items[action.payload];
      } else {
        item.quantity -= 1;
      }
    },

    removeFromCart: (state, action: PayloadAction<number>) => {
      delete state.items[action.payload];
    },

    clearCart: (state) => {
      state.items = {};
    },
    restoreGuestCart: (
      state,
      action: PayloadAction<
        {
          product: TGetAllStoreProductsData;
          storeProductId: number;
          storeProductTitle: string;
          quantity: number;
        }[]
      >,
    ) => {
      action.payload.forEach((item) => {
        const id = item.product.id;

        if (state.items[id]) {
          state.items[id].quantity += item.quantity;
        } else {
          state.items[id] = {
            product: item.product,
            storeProductId: item.storeProductId,
            storeProductTitle: item.storeProductTitle,
            quantity: item.quantity,
          };
        }
      });
    },
    setPendingOrder(state, action: PayloadAction<TCartFormInitialValues>) {
      state.pendingOrder = action.payload;
    },

    clearPendingOrder(state) {
      state.pendingOrder = null;
    },
  },
});

export const {
  addToCart,
  increase,
  decrease,
  removeFromCart,
  clearCart,
  restoreGuestCart,
  clearPendingOrder,
  setPendingOrder,
} = cartSlice.actions;

export const cartReducer = cartSlice.reducer;
